import {useCallback, useRef, useState} from 'react';

import {removeSeatFromUser} from 'src/openapi/admin/apis/UserSeatAssignmentsApi';
import {SeatAssignRequestState} from 'src/openapi/admin/models/SeatAssignRequest';
import {useAppDispatch} from 'src/store/hooks';
import {getError} from 'src/utils/get-error';

export const useRemoveSeatFromUser = (userId: number) => {
    const apiDispatch = useAppDispatch();
    const [removing, setRemoving] = useState(false);
    const [error, setError] = useState('');
    const isRequestPending = useRef(false);

    const remove = useCallback(async (productSubscriptionId: string) => {
        if (isRequestPending.current) {
            return false;
        }

        isRequestPending.current = true;
        setRemoving(true);
        setError('');

        try {
            const response = await apiDispatch(removeSeatFromUser({
                userId,
                seatAssignRequest: {state: SeatAssignRequestState.REMOVE, productSubscriptionId},
            }));

            if (response.payload?.success) {
                return true;
            }

            setError(getError({error: response.payload?.data, separator: '. '}));
            return false;
        } finally {
            isRequestPending.current = false;
            setRemoving(false);
        }
    }, [apiDispatch, userId]);

    return {remove, removing, error};
};
